import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signUp } from 'aws-amplify/auth';
import { track } from '../lib/analytics';
import { useAuth } from '../useAuth';

export default function SignUp() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  // If a session is already active (e.g. user revisits /signup), skip ahead.
  useEffect(() => {
    if (!loading && user) navigate('/dashboard', { replace: true });
  }, [loading, user, navigate]);

  async function onSubmit(e) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await signUp({
        username: email,
        password,
        options: {
          userAttributes: { email },
          autoSignIn: true,
        },
      });
      track('signup', { email });
      navigate(`/verify?email=${encodeURIComponent(email)}`);
    } catch (e) {
      setErr(e.message || 'Sign-up failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="min-h-screen bg-neutral-950 text-neutral-100 flex items-center justify-center px-6">
      <form onSubmit={onSubmit} className="w-full max-w-sm space-y-4">
        <h1 className="text-3xl font-semibold mb-2">Create account</h1>
        <p className="text-sm text-neutral-400 mb-4">
          10+ characters, mix of upper, lower, and digits.
        </p>
        <input
          type="email"
          required
          placeholder="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-3 py-2 rounded bg-neutral-900 border border-neutral-800 focus:border-indigo-500 outline-none"
        />
        <input
          type="password"
          required
          minLength={10}
          placeholder="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-3 py-2 rounded bg-neutral-900 border border-neutral-800 focus:border-indigo-500 outline-none"
        />
        {err && <p className="text-sm text-red-400">{err}</p>}
        <button
          type="submit"
          disabled={busy}
          className="w-full px-4 py-2 rounded bg-indigo-500 hover:bg-indigo-400 disabled:opacity-50 text-white font-medium"
        >
          {busy ? 'Creating…' : 'Create account'}
        </button>
        <p className="text-sm text-neutral-400 text-center">
          Already have an account?{' '}
          <Link to="/signin" className="text-indigo-400 hover:text-indigo-300">
            Sign in
          </Link>
        </p>
      </form>
    </main>
  );
}
